import React, {memo} from 'react';
import UseRailScrollEvent from "../../common/hooks/useScrollEvent";
import styled from "styled-components";

const SmallRail = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 300px;
  height: 250px;
  margin-bottom: 15px;
`;


const LeftSideWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 300px;
  height: 600px;
`



const StickyBox = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
`;



const StickyBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  min-width: 300px;
  padding-top: 20px;
  position: relative;
`;

const LeftRailAd = memo(() => {
    const ref = UseRailScrollEvent();
    return null
    // return (
    //     <StickyBoxWrapper>
    //         <StickyBox ref={ref}>
    //             <SmallRail data-ad={'left-rail-1'}>
    //                 <VenatusAd placementName={'vertical_sticky'}/>
    //             </SmallRail>
    //             <LeftSideWrapper  data-ad={"left-rail-2"}>
    //                 <VenatusAd placementName={'vertical_sticky'}/>
    //             </LeftSideWrapper>
    //         </StickyBox>
    //     </StickyBoxWrapper>
    // )
})

export default LeftRailAd;